import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';
import { ConfigureResponse } from './configure';

export enum ConfigurationType {
  CONFIGURATION_INVENTORY = 'CONFIGURATION_INVENTORY',
  FULL_INVENTORY = 'FULL_INVENTORY',
  SUMMARY_INVENTORY = 'SUMMARY_INVENTORY'
}

export interface GetFullConfigurationCommand {
  configurationType?: ConfigurationType;
}

const client = createClient('/rest/operator-api/charging-stations');

export const getFullConfiguration: SaveOperation<GetFullConfigurationCommand, ConfigureResponse, string> =
  postRequestFactory<GetFullConfigurationCommand, ConfigureResponse, string>(client, {
    pattern: '/{chargingStationId}/get-full-configuration',
    permissionId: commandPermissions.GET_FULL_CONFIGURATION
  });
